/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import moment from 'moment'
import React, { Fragment, useCallback, useState } from 'react'
import Picker from 'react-mobile-picker'

function getDayArray(year, month) {
    const dayCount = new Date(year, month, 0).getDate()
    return Array.from({ length: dayCount }, (_, i) => String(i + 1).padStart(2, '0'))
}

export default function DatePickerPicker({pickerValue, setPickerValue}) {
    const handlePickerChange = useCallback((newValue, key) => {
        if (key === 'day' ) {
            setPickerValue(newValue)
            return
        }

        const { year, month } = newValue
        const newDayArray = getDayArray(Number(year), Number(month))
        const newDay = newDayArray.includes(newValue.day) ? newValue.day : newDayArray[newDayArray.length - 1]
        setPickerValue({ ...newValue, day: newDay })
    }, [])
    
    return (
        <>
            <Picker
                className='picker'
                itemHeight={48}
                value={pickerValue}
                onChange={handlePickerChange}
                wheelMode="normal"
                height={142}
                data-testid="dob_picker"
            >
                <Picker.Column name="month" data-testid="month">
                    { Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')).map((month) => (
                        <Picker.Item key={month} value={month}>
                            {({ selected }) => (
                                <div className={selected ? 'font-normal text-[#007EB4] text-[24px] h-[48px] flex items-center w-full justify-center mr-[15px]' 
                                    : `text-[#333] text-sm font-normal h-[48px] w-[62px] flex justify-center items-center mr-[15px] ${month < Number(pickerValue.month) ? 'rounded-t-[12px]' : 'rounded-b-[12px]'}`} data-testid={moment().month(month - 1).format('MMM')}>{moment().month(month - 1).format('MMM')}</div>
                            )}
                        </Picker.Item>
                    ))}
                </Picker.Column>
                <Picker.Column name="day" data-testid="day">
                    { getDayArray(Number(pickerValue.year), Number(pickerValue.month)).map((day) => (
                        <Picker.Item key={day} value={day}>
                            {({ selected }) => (
                                <div className={selected ? 'font-normal text-[#007EB4] text-[24px] h-[48px] flex items-center w-full justify-center' 
                                    : `text-[#333] text-sm font-normal h-[48px] w-[62px] flex justify-center items-center ${day < Number(pickerValue.day) ? 'rounded-t-[12px]' : 'rounded-b-[12px]'}`} data-testid={day}>{day}</div>
                            )}
                        </Picker.Item>
                    ))}
                </Picker.Column>
                <Picker.Column name="year" data-testid="year">
                    { Array.from({ length: moment().year() + 1 - 1923 }, (_, i) => `${1923 + i}`).map((year) => (
                        <Picker.Item key={year} value={year}>
                            {({ selected }) => (
                                <div className={selected ? 'font-normal text-[#007EB4] text-[24px] h-[48px] flex items-center w-full justify-center ml-[15px]' 
                                    : `text-[#333] text-sm font-normal h-[48px] w-[62px] flex justify-center items-center ml-[15px] ${year < Number(pickerValue.year) ? 'rounded-t-[12px]' : 'rounded-b-[12px]'}`} data-testid={year}>{year}</div>
                            )}
                        </Picker.Item>
                    ))}
                </Picker.Column>
            </Picker>
        </>
    )
}